// ============================================================
// Factory Direct Supply — AI Technical Support Widget
// Version 1.0.0
//
// BEFORE GOING LIVE — replace these two placeholders:
//   PROXY_ENDPOINT    — your Cloudflare Worker URL
//   GOOGLE_SCRIPT_URL — your deployed Google Apps Script URL
// ============================================================

(function () {
  'use strict';

  // ── Placeholders: fill in after deployment ─────────────────
  var PROXY_ENDPOINT    = 'https://artistic-vision-production-aa88.up.railway.app';
  var GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbwCcbSD4lPk_QQh3BKbcCIU9HxiFMkNvx-Em5LxR4r1SadyeT9ASbes0DfXATEX21nz/exec';

  // ── Product context from Shopify Liquid ───────────────────
  var cfg           = window.FDS_WIDGET_CONFIG || {};
  var PRODUCT_TITLE       = cfg.product_title       || document.title;
  var PRODUCT_VENDOR      = cfg.product_vendor      || '';
  var PRODUCT_URL         = cfg.product_url         || window.location.href;
  var PRODUCT_DESCRIPTION = cfg.product_description || '';
  var CONTACT_URL         = cfg.contact_url         || '/pages/contact-us';

  // ── Styles ────────────────────────────────────────────────
  var CSS = [
    '#fds-widget{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;max-width:100%;width:100%;margin:32px 0;border:1px solid #E1E3E4;border-radius:8px;overflow:hidden;background:#F3F5F6}',
    '#fds-widget *{box-sizing:border-box}',

    /* header */
    '#fds-widget-header{background:#3d4551;color:#fff;padding:14px 18px;display:flex;align-items:center;gap:12px}',
    '#fds-widget-badge{width:38px;height:38px;background:#347C4C;border:2px solid #fff;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0}',
    '#fds-widget-badge svg{display:block}',
    '#fds-widget-title{margin:0;font-size:15px;font-weight:600;line-height:1.2}',
    '#fds-widget-subtitle{margin:2px 0 0;font-size:12px;opacity:.8}',

    /* body */
    '#fds-widget-body{padding:16px 18px;background:#F3F5F6}',
    '#fds-widget-row{display:flex;gap:8px;align-items:flex-start}',
    '#fds-widget-input{flex:1;padding:10px 14px;border:1px solid #E1E3E4;border-radius:6px;font-size:14px;color:#131921;background:#fff;resize:none;min-height:66px;max-height:120px;overflow-y:auto;line-height:1.5;font-family:inherit}',
    '#fds-widget-input:focus{outline:none;border-color:#347C4C;box-shadow:0 0 0 2px rgba(52,124,76,.15)}',
    '#fds-widget-input::placeholder{color:#9ca3af;font-size:15px}',
    '#fds-widget-submit{padding:0 18px;background:#347C4C;color:#fff;border:none;border-radius:6px;font-size:14px;font-weight:600;cursor:pointer;white-space:nowrap;transition:background .2s;height:44px;flex-shrink:0;font-family:inherit}',
    '#fds-widget-submit:hover{background:#2d6b40}',
    '#fds-widget-submit:disabled{background:#9ab8a2;cursor:not-allowed}',
    '#fds-widget-hint{margin:8px 0 0;font-size:14px;color:#6b7280;line-height:1.4;font-weight:bold}',
    '#fds-widget-hint a{color:#347C4C}',

    /* loading */
    '#fds-widget-loading{display:none;margin-top:14px;font-size:13px;color:#6b7280;align-items:center;gap:8px}',
    '#fds-widget-loading.fds-visible{display:flex}',
    '.fds-spinner{width:16px;height:16px;border:2px solid #E1E3E4;border-top-color:#347C4C;border-radius:50%;animation:fds-spin .7s linear infinite;flex-shrink:0}',
    '@keyframes fds-spin{to{transform:rotate(360deg)}}',

    /* error */
    '#fds-widget-error{display:none;margin-top:12px;padding:10px 14px;background:#fef2f2;border:1px solid #fca5a5;border-radius:6px;font-size:13px;color:#991b1b}',
    '#fds-widget-error.fds-visible{display:block}',

    /* answer panel */
    '#fds-widget-answer{display:none;margin-top:16px;background:#fff;border:1px solid #E1E3E4;border-left:4px solid #347C4C;border-radius:0 6px 6px 0;padding:14px 16px}',
    '#fds-widget-answer.fds-visible{display:block}',
    '#fds-widget-answer-label{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.06em;color:#347C4C;margin:0 0 8px}',
    '#fds-widget-answer-text{font-size:14px;color:#131921;line-height:1.65;white-space:pre-wrap;word-break:break-word}',
    '#fds-widget-answer-text a{color:#347C4C}',
    'a.fds-product-link{display:inline-block;margin:4px 0;padding:6px 14px;background:#347C4C;color:#fff!important;border-radius:5px;font-size:13px;font-weight:600;text-decoration:none;transition:background .2s}',
    'a.fds-product-link:hover{background:#2d6b40}',

    /* escalation CTA */
    '#fds-widget-escalate{display:none;margin-top:12px;padding:10px 14px;background:#fff8f0;border:1px solid #f0c27f;border-radius:6px;font-size:13px;color:#131921;line-height:1.5}',
    '#fds-widget-escalate.fds-visible{display:block}',
    '#fds-widget-escalate a{color:#347C4C;font-weight:600}',

    /* responsive */
    '@media(max-width:480px){#fds-widget-row{flex-direction:column}#fds-widget-input{width:100%}#fds-widget-submit{width:100%}}',
  ].join('');

  // ── DOM builders ──────────────────────────────────────────
  function injectStyles() {
    var s = document.createElement('style');
    s.id = 'fds-widget-styles';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function buildWidget() {
    var wrap = document.createElement('div');
    wrap.id = 'fds-widget';
    wrap.setAttribute('aria-label', 'AI Technical Support');
    wrap.innerHTML =
      '<div id="fds-widget-header">' +
        '<div id="fds-widget-badge">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<circle cx="12" cy="12" r="10"/>' +
            '<path d="M12 16v-4M12 8h.01"/>' +
          '</svg>' +
        '</div>' +
        '<div>' +
          '<p id="fds-widget-title">Ask a Technical Question</p>' +
          '<p id="fds-widget-subtitle">Powered by AI \u2014 specs, compatibility &amp; recommendations</p>' +
        '</div>' +
      '</div>' +
      '<div id="fds-widget-body">' +
        '<div id="fds-widget-row">' +
          '<textarea id="fds-widget-input" rows="2" placeholder="e.g. Is this compatible with a 20V battery? What blade fits this saw?" aria-label="Your technical question"></textarea>' +
          '<button id="fds-widget-submit" type="button">Ask</button>' +
        '</div>' +
        '<p id="fds-widget-hint">Ask about specs, compatibility, or product comparisons. For orders &amp; pricing, call <a href="tel:8887988822">888-798-8822</a>.</p>' +
        '<div id="fds-widget-loading" role="status" aria-live="polite"><div class="fds-spinner" aria-hidden="true"></div>Looking up verified specs\u2026</div>' +
        '<div id="fds-widget-error" role="alert"></div>' +
        '<div id="fds-widget-answer" aria-live="polite">' +
          '<p id="fds-widget-answer-label">Technical Answer</p>' +
          '<div id="fds-widget-answer-text"></div>' +
          '<div id="fds-widget-escalate">' +
            '<strong>Need more help?</strong> Our team is happy to assist.<br>' +
            '\uD83D\uDCDE <a href="tel:8887988822">888-798-8822</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="' + CONTACT_URL + '">Contact Us Online</a>' +
          '</div>' +
        '</div>' +
      '</div>';
    return wrap;
  }

  function mount(widget) {
    // Ordered from most to least specific — covers Dawn, Debut, and most common themes
    var selectors = [
      '.product-details-container',
      '.product__info-container',
      '.product-single__description',
      '.product__description',
      '.product-description',
      '[data-section-type="product-template"]',
      '#product-description',
      '.product-info',
      '.product-details',
      '.product__info',
      'form[action*="/cart/add"]',
      '.product',
      'main[id]',
      'main',
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) {
        el.insertAdjacentElement('afterend', widget);
        return;
      }
    }
    document.body.appendChild(widget);
  }

  // ── State helpers ─────────────────────────────────────────
  function setLoading(on) {
    document.getElementById('fds-widget-loading').classList.toggle('fds-visible', on);
    document.getElementById('fds-widget-submit').disabled = on;
  }

  function showError(msg) {
    var el = document.getElementById('fds-widget-error');
    el.textContent = msg;
    el.classList.add('fds-visible');
  }

  function clearError() {
    document.getElementById('fds-widget-error').classList.remove('fds-visible');
  }

  // ── Product URL resolution ────────────────────────────────
  // Strip manufacturer prefix (e.g. SIM-, DW-) and quantity suffix (e.g. " -24", " (24)", " 24pk")
  // so the suggest API gets just the core part number (e.g. "APLH24")
  function extractCorePartNumber(query) {
    var q = query.trim();
    // Remove common manufacturer prefixes: SIM-, DW-, DWA-, MKT-, etc.
    q = q.replace(/^[A-Z]{2,4}-/i, '');
    // Remove trailing quantity/pack indicators: " -24", " (24)", " 24", " x24", " pk24", etc.
    q = q.replace(/\s*[-x]?\s*\(?\d+\)?\s*(pk|pack|ea|pcs?)?$/i, '');
    return q.trim();
  }

  function resolveSearchLinks(text) {
    var pattern = /https?:\/\/(?:www\.)?factorydirectsupply\.com\/search\?q=([^\s<]+)/g;
    var matches = [];
    var match;
    while ((match = pattern.exec(text)) !== null) {
      var raw = decodeURIComponent(match[1].replace(/\+/g, ' '));
      matches.push({ full: match[0], query: extractCorePartNumber(raw) });
    }
    if (matches.length === 0) return Promise.resolve(text);

    var unique = matches.filter(function (m, i, arr) {
      return arr.findIndex(function (x) { return x.full === m.full; }) === i;
    });

    var promises = unique.map(function (m) {
      return fetch('/search/suggest.json?q=' + encodeURIComponent(m.query) + '&resources[type]=product&resources[limit]=1')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var results = data && data.resources && data.resources.results && data.resources.results.products;
          if (results && results.length > 0) {
            return { full: m.full, query: m.query, url: 'https://factorydirectsupply.com' + results[0].url };
          }
          return { full: m.full, query: m.query, url: null };
        })
        .catch(function () { return { full: m.full, query: m.query, url: null }; });
    });

    return Promise.all(promises).then(function (resolved) {
      var result = text;
      resolved.forEach(function (r) {
        var replacement = r.url
          ? r.url
          : r.full;
        result = result.split(r.full).join(replacement);
      });
      return result;
    });
  }

  function renderAnswer(text, escalated) {
    var safe = text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/(https?:\/\/(?:www\.)?factorydirectsupply\.com\/products\/[^\s<"')]+)/g,
        '<a class="fds-product-link" href="$1" target="_blank" rel="noopener noreferrer">View Product &rarr;</a>')
      .replace(/(?<!href=")(https?:\/\/(?!(?:www\.)?factorydirectsupply\.com\/products\/)[^\s<"')]+)/g,
        '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>');

    document.getElementById('fds-widget-answer-text').innerHTML = safe;
    document.getElementById('fds-widget-answer').classList.add('fds-visible');
    document.getElementById('fds-widget-escalate').classList.toggle('fds-visible', !!escalated);
  }

  function showAnswer(text, escalated) {
    resolveSearchLinks(text).then(function (resolved) {
      renderAnswer(resolved, escalated);
    });
  }

  // ── Session persistence ───────────────────────────────────
  var SESSION_KEY = 'fds_answer_' + PRODUCT_URL;

  function saveToSession(answer, escalated) {
    try {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify({ answer: answer, escalated: escalated }));
    } catch (e) {}
  }

  function restoreFromSession() {
    try {
      var stored = sessionStorage.getItem(SESSION_KEY);
      if (stored) {
        var data = JSON.parse(stored);
        showAnswer(data.answer, data.escalated);
      }
    } catch (e) {}
  }

  // ── Google Sheets logging ─────────────────────────────────
  function logToSheets(question, answer, escalated) {
    if (!GOOGLE_SCRIPT_URL || GOOGLE_SCRIPT_URL.indexOf('YOUR_SCRIPT_ID') !== -1) {
      console.warn('[FDS Widget] Google Sheets URL not configured.');
      return;
    }
    var payload = JSON.stringify({
      product: PRODUCT_TITLE,
      productUrl: PRODUCT_URL,
      question: question,
      answer: answer,
      escalated: escalated,
      source: 'factorydirectsupply.com',
    });
    console.log('[FDS Widget] Logging to Google Sheets...', payload);
    // Use no-cors to avoid CORS redirect issues with Google Apps Script
    fetch(GOOGLE_SCRIPT_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain' },
      body: payload,
    })
    .then(function () {
      console.log('[FDS Widget] Google Sheets log sent successfully.');
    })
    .catch(function (err) {
      console.error('[FDS Widget] Google Sheets logging failed:', err);
    });
  }

  // ── Test function (call from browser console: FDSWidget.testSheets()) ──
  window.FDSWidget = {
    testSheets: function () {
      console.log('[FDS Widget] Sending test log to Google Sheets...');
      logToSheets(
        'TEST QUESTION — widget connection check',
        'TEST ANSWER — if this row appears in the sheet, logging is working.',
        false
      );
    }
  };

  // ── Submit handler ────────────────────────────────────────
  function handleSubmit() {
    var input    = document.getElementById('fds-widget-input');
    var question = input.value.trim();
    if (!question) return;

    clearError();
    setLoading(true);
    document.getElementById('fds-widget-answer').classList.remove('fds-visible');

    fetch(PROXY_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        question: question,
        product_title: PRODUCT_TITLE,
        product_vendor: PRODUCT_VENDOR,
        product_url: PRODUCT_URL,
        product_description: PRODUCT_DESCRIPTION,
      }),
    })
    .then(function (res) {
      if (res.status === 429) {
        showError("You've reached the daily question limit. Please call us at 888-798-8822 for further assistance.");
        setLoading(false);
        return null;
      }
      if (!res.ok) {
        showError('Something went wrong. Please try again or call 888-798-8822.');
        setLoading(false);
        return null;
      }
      return res.json();
    })
    .then(function (data) {
      if (!data) return;
      if (data.error) {
        showError(data.error);
      } else {
        showAnswer(data.answer, data.escalated);
        saveToSession(data.answer, data.escalated);
        logToSheets(question, data.answer, data.escalated);
        input.value = '';
        input.style.height = 'auto';
      }
    })
    .catch(function () {
      showError('Network error. Please check your connection or call 888-798-8822.');
    })
    .finally(function () {
      setLoading(false);
    });
  }

  // ── Auto-resize textarea ──────────────────────────────────
  function autoResize(textarea) {
    textarea.style.height = 'auto';
    textarea.style.height = Math.min(textarea.scrollHeight, 120) + 'px';
  }

  // ── Event binding ─────────────────────────────────────────
  function bindEvents() {
    var input  = document.getElementById('fds-widget-input');
    var submit = document.getElementById('fds-widget-submit');

    input.addEventListener('input', function () { autoResize(input); });

    submit.addEventListener('click', handleSubmit);

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        handleSubmit();
      }
    });
  }

  // ── Init ──────────────────────────────────────────────────
  function init() {
    // Don't double-mount
    if (document.getElementById('fds-widget')) return;
    injectStyles();
    var widget = buildWidget();
    mount(widget);
    bindEvents();
    restoreFromSession();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
